export type PhoneDirectorySourceType = 'employee' | 'businessPartner' | 'contact';

export type PhoneDirectoryNavigateTo = 'employee' | 'business-partner';

export type PhoneDirectorySourceFilter = 'all' | PhoneDirectorySourceType;

export interface PhoneDirectoryEntry {
  sourceType: PhoneDirectorySourceType;
  sourceId: string;
  displayName: string;
  secondaryName?: string | null;
  code?: string | null;
  phone?: string | null;
  mobile?: string | null;
  email?: string | null;
  departmentOrRole?: string | null;
  isPrimary?: boolean | null;
  navigateTo: PhoneDirectoryNavigateTo;
  navigateId: string;
}

export interface PhoneDirectoryListMeta {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface PhoneDirectoryListResponse {
  success: boolean;
  message: string;
  data: PhoneDirectoryEntry[] | null;
  meta: PhoneDirectoryListMeta | null;
}

export interface PhoneDirectoryQuery {
  keyword: string;
  source: PhoneDirectorySourceFilter;
  pageNumber: number;
  pageSize: number;
}

export interface PhoneDirectoryPage {
  items: PhoneDirectoryEntry[];
  totalRecords: number;
}

export const PHONE_DIRECTORY_SOURCE_OPTIONS: { value: PhoneDirectorySourceFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'employee', label: 'Employees' },
  { value: 'businessPartner', label: 'Business partners' },
  { value: 'contact', label: 'Contacts' },
];
